import { render, staticRenderFns } from "./CustomerBill.vue?vue&type=template&id=32603f44&scoped=true"
import script from "./CustomerBill.vue?vue&type=script&lang=js"
export * from "./CustomerBill.vue?vue&type=script&lang=js"
import style0 from "./CustomerBill.vue?vue&type=style&index=0&id=32603f44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32603f44",
  null
  
)

export default component.exports